import {
  GetVehicleTypeQueryParamsType,
  GetVehicleTypeQueryResponseType,
} from '@/common/queries/getVehicleType/getVehicleTypeQuery.type';
import { BASE_URL, fetchApi } from '@/config/axiosSetting';

export const getVehicleType = (
  param: GetVehicleTypeQueryParamsType,
): Promise<GetVehicleTypeQueryResponseType> =>
  fetchApi.get(`${BASE_URL}api/base_info/vehicle_type/info/`, {
    params: {
      damaged_pk: param.damaged_pk,
      file_pk: param.file_pk,
    },
  });
